import UserChatBubble from '../UserChatBubble'
import UserMessageRow from '../UserMessageRow'
import UserMessageText from '../UserMessageText'

export default function ChatThreadExchangeUserBlock({
  currentUser,
  exchangeId,
  editingExchangeId,
  draftByExchangeId,
  setDraftByExchangeId,
  startEdit,
  cancelEdit,
  sendEdit,
  queryActiveOrdinal,
  queryCount,
  queryCanPrev,
  queryCanNext,
  onQueryPrev,
  onQueryNext,
  focusedMessageId,
}) {
  return (
    <UserMessageRow
      messageId={currentUser.id}
      highlighted={focusedMessageId === currentUser.id}
    >
      <UserChatBubble
        text={currentUser.text}
        attachments={currentUser.files}
        onEdit={() => startEdit(currentUser)}
        isEditing={editingExchangeId === exchangeId}
        draftText={draftByExchangeId[exchangeId] ?? currentUser.text}
        onDraftTextChange={(v) =>
          setDraftByExchangeId((prev) => ({ ...prev, [exchangeId]: v }))
        }
        onCancelEdit={() => cancelEdit(exchangeId)}
        onSendEdit={() => sendEdit(exchangeId)}
        versionLabel={`${queryActiveOrdinal + 1}/${queryCount}`}
        showVersionNav={queryCount > 1}
        onPrevVersion={onQueryPrev}
        onNextVersion={onQueryNext}
        prevDisabled={!queryCanPrev}
        nextDisabled={!queryCanNext}
      >
        <UserMessageText text={currentUser.text} />
      </UserChatBubble>
    </UserMessageRow>
  )
}
